<template>
    <div>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>我的工作台</span>
            </div>
            <div class="text item">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-calendar v-model="calendar"></el-calendar>
                    </el-col>
                    <el-col :span="12">
                        <el-row :gutter="20" style="margin-top:50px">
                            <el-col :span="12" v-for="(item,index) in list" style="margin-bottom:20px" :key="index">
                                <el-card shadow="hover" class="node" @click.native="nodeLink(item.url)">
                                    <el-row>
                                        <el-col :span="3">
                                            <i class="el-icon-message-solid"></i>
                                        </el-col>
                                        <el-col :span="21">
                                            <p>NUM：
                                                <span style="font-size:22px;font-weight:600;color:#ed6d23">
                                                    {{item.total}}
                                                </span>
                                            </p>
                                            <p>{{item.noticeType}}</p>
                                        </el-col>
                                    </el-row>
                                    
                                </el-card>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </el-card>

        <el-dialog
            title="提醒"
            :visible.sync="dialogVisible"
            width="50%">
            <my-tag type="danger" style="font-size:20px">以下项目已发布中标公告，请尽快发布中标结果通知书</my-tag>
            <my-table :data="tableData" style="margin-top:20px;max-height:300px;overflow:auto">
                <el-table-column label="招标项目名称" prop="zbproname" min-width="180"></el-table-column>
                <el-table-column label="招标项目编号" prop="zbprocode" min-width="180"></el-table-column>
                <el-table-column label="标段名称" prop="bdname" min-width="180"></el-table-column>
                <el-table-column label="标段编号" prop="bdcode" min-width="180"></el-table-column>
            </my-table>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],

    data() {
        return{
            calendar:new Date(),
            list:[],
            dialogVisible:false,
            tableData:[],
        }
    },
    methods: {
        nodeLink(url){
            window.open(url)
        }
    },
    mounted() {
        var that = this;
        setSession('isRevision',0)
        that.$get(`${this.getGetters('mngUrl')}/agent/notice/initHomePage.json`, data => {
            that.list = data.list;
        }) 
        // 获取
        that.$get(`${this.getGetters('mngUrl')}/agent/notice/zbJgTzsNotice.json`, data => {
            that.tableData = data;
            if(that.tableData.length>0){
                that.dialogVisible = true;
            }
        }) 
        
    },
}
</script>

<style scoped lang="scss">
    .box-card{ width: 1100px; margin: 50px auto; }
    .node{ cursor: pointer; }
    /deep/ .el-card__header{ text-align: center; border-bottom: none  }
    /deep/ .el-card__header .clearfix span{ font-weight: 600; font-size: 22px;}
    /deep/ .el-calendar-table .el-calendar-day{ height: 65px;}
    /deep/ .el-icon-message-solid{ margin-top: 16px; font-size: 22px;}
    /deep/ .el-calendar-table tr td:first-child{ border-color: #ddd !important;}
    /deep/ .el-calendar-table td,.el-card,.el-calendar-table tr:first-child td{ border-color: #ddd !important;}
    /deep/ .el-calendar__header{ border-color: #ddd;}
</style>